import { MonitorSmartphone, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

const when = (iso) => new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export function DeviceLimitPrompt({ info, busy, onSignOut }) {
  return (
    <div data-testid="device-limit-prompt" className="rounded-2xl border border-[#FFB800]/40 bg-[#FFB800]/10 p-4 space-y-3">
      <p className="text-sm text-[#FFD466] font-semibold">{info.msg}</p>
      <p className="text-xs text-slate-400">Pick a device to sign out, and you'll be logged in here.</p>
      {info.sessions.map((s) => (
        <div key={s.sid} data-testid={`device-row-${s.sid}`} className="flex items-center gap-3 rounded-xl bg-[#0B0F19] border border-[#26334D] p-3">
          <MonitorSmartphone className="h-4 w-4 text-[#00E5A3] shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold truncate">{s.device}</p>
            <p className="text-xs text-slate-500">Last active {when(s.last_seen)}</p>
          </div>
          <Button type="button" data-testid={`device-signout-${s.sid}`} disabled={busy} onClick={() => onSignOut(s.sid)}
            className="h-8 rounded-full bg-white text-[#0B0F19] hover:bg-slate-200 text-xs font-semibold">
            <LogOut className="h-3.5 w-3.5 mr-1" /> Sign out
          </Button>
        </div>
      ))}
    </div>
  );
}
